/* ==============================================================================
   QUICK VIEW DRAWER — IMAGE CAROUSEL (07-2026)
   The drawer content arrives via AJAX injection, so inline scripts in the
   fetched HTML never run. This file is loaded with the drawer shell
   (snippets/product-drawer.liquid), watches for injected galleries, and
   upgrades the vertical media stack into a scroll-snap carousel with
   arrows + dots. Pairs with quick-view-carousel.css.

   Also resolves the shipping preview ("Checking shipping...") inside the
   drawer — its inline updater script suffers the same injection problem,
   so we mirror its cart fetch + copy logic here for the drawer only.
   ============================================================================== */
(function () {
  'use strict';

  var CHEVRON_LEFT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="15 18 9 12 15 6"></polyline></svg>';
  var CHEVRON_RIGHT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 18 15 12 9 6"></polyline></svg>';

  function initGallery(gallery) {
    if (gallery.dataset.qvCarousel) return;
    gallery.dataset.qvCarousel = '1';

    var container = gallery.closest('.product-quick-images--container') || gallery.parentNode;

    /* The section renders the selected variant's featured media once on its
       own AND again inside the media loop — hide the duplicate. */
    var all = Array.prototype.slice.call(gallery.querySelectorAll('.product-quick-images__slide'));
    var seen = {};
    var slides = [];
    all.forEach(function (slide) {
      var id = slide.getAttribute('data-media-id') || '';
      if (id && seen[id]) {
        slide.style.display = 'none';
        return;
      }
      seen[id] = true;
      slides.push(slide);
    });

    if (!slides.length) return;
    container.classList.add('qv-carousel');
    if (slides.length < 2) return;

    /* ── Controls ─────────────────────────────────────────── */
    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'qv-nav qv-prev';
    prev.setAttribute('aria-label', 'Previous image');
    prev.innerHTML = CHEVRON_LEFT;

    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'qv-nav qv-next';
    next.setAttribute('aria-label', 'Next image');
    next.innerHTML = CHEVRON_RIGHT;

    var dots = document.createElement('div');
    dots.className = 'qv-dots';
    var dotEls = slides.map(function (slide, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'qv-dot';
      dot.setAttribute('aria-label', 'Go to image ' + (i + 1));
      dot.addEventListener('click', function () {
        scrollToIndex(i);
      });
      dots.appendChild(dot);
      return dot;
    });

    container.appendChild(prev);
    container.appendChild(next);
    container.appendChild(dots);

    function slideLeft(slide) {
      return slide.offsetLeft - gallery.offsetLeft;
    }

    function scrollToIndex(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      gallery.scrollTo({ left: slideLeft(slides[i]), behavior: 'smooth' });
    }

    function currentIndex() {
      var pos = gallery.scrollLeft;
      var best = 0;
      var bestDist = Infinity;
      slides.forEach(function (slide, i) {
        var d = Math.abs(slideLeft(slide) - pos);
        if (d < bestDist) {
          bestDist = d;
          best = i;
        }
      });
      return best;
    }

    function update() {
      var i = currentIndex();
      dotEls.forEach(function (dot, j) {
        dot.classList.toggle('is-active', j === i);
      });
      if (i === 0) {
        prev.setAttribute('disabled', 'disabled');
      } else {
        prev.removeAttribute('disabled');
      }
      if (i === slides.length - 1) {
        next.setAttribute('disabled', 'disabled');
      } else {
        next.removeAttribute('disabled');
      }
    }

    prev.addEventListener('click', function () {
      scrollToIndex(currentIndex() - 1);
    });
    next.addEventListener('click', function () {
      scrollToIndex(currentIndex() + 1);
    });

    var raf = null;
    gallery.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        update();
      });
    }, { passive: true });

    /* Start on the variant's featured (is-active) slide */
    var active = gallery.querySelector('.product-quick-images__slide.is-active');
    if (active && active.style.display !== 'none') {
      gallery.scrollLeft = slideLeft(active);
    }
    update();
  }

  function initShippingPreview(preview) {
    if (preview.dataset.qvShipping) return;
    preview.dataset.qvShipping = '1';

    /* Already resolved (inline script ran, e.g. on a full page load)? */
    if (!preview.querySelector('.shipping-preview__loading')) return;

    var threshold = parseInt(preview.getAttribute('data-threshold'), 10);
    var productPrice = parseInt(preview.getAttribute('data-product-price'), 10) || 0;
    var moneyFormat = preview.getAttribute('data-money-format') || '${{amount}}';
    var textEl = preview.querySelector('.shipping-preview__text');
    if (!textEl || isNaN(threshold)) return;

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      return moneyFormat
        .replace(/\{\{\s*amount\s*\}\}/, amount)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','));
    }

    function render(cartTotal) {
      var projectedTotal = cartTotal + productPrice;
      if (cartTotal >= threshold) {
        preview.classList.add('shipping-preview--free');
        textEl.innerHTML = '<strong>Free shipping</strong> on your order';
      } else if (projectedTotal >= threshold) {
        preview.classList.add('shipping-preview--free');
        textEl.innerHTML = '<strong>Free shipping</strong> when you add this item';
      } else {
        preview.classList.remove('shipping-preview--free');
        var remaining = threshold - projectedTotal;
        textEl.innerHTML = 'Add <strong>' + formatMoney(remaining) + '</strong> more for free shipping';
      }
    }

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart.total_price); })
      .catch(function () { render(0); });
  }

  function scan() {
    var galleries = document.querySelectorAll('.product-drawer .product-quick-images');
    Array.prototype.forEach.call(galleries, initGallery);
    var previews = document.querySelectorAll('.product-drawer .shipping-preview');
    Array.prototype.forEach.call(previews, initShippingPreview);
  }

  var timer = null;
  var observer = new MutationObserver(function () {
    clearTimeout(timer);
    timer = setTimeout(scan, 100);
  });

  function start() {
    scan();
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
